export const NOT_LOGIN = 'NOT_LOGIN' ;
export const PACKAGE_EQUITY_ERROR = 'PACKAGE_EQUITY_ERROR' ;
export const TOKEN_INVALID = 'TOKEN_INVALID' ;
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR' ;
export const TOKEN_INACTIVITY = 'TOKEN_INACTIVITY' ;